export const MAX_FILES_LENGTH = 10;
export const MAX_FILE_SIZE = 20;
export const DOCUMENT_TYPES =
  '.jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
